import { writable } from 'svelte/store';

function createProductStore() {
	const { subscribe, set, update } = writable(null);

	return {
		subscribe,
		setProduct: async (product) => {
            // Set the data
            set(product);
        },
		reset: () => {
            set(undefined);
        }
	};
}

export const currentProduct = createProductStore();